import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptKeyShout } from "../adapters/adaptKeyShouts";

const fetchKeyShout = async (id: number) => {
	const response = await cmsClient.get<IKeyShout>(
		`/homepage/admin/keyshout/${id}/`
	);

	return response.data;
};

const useKeyShout = (id: number) => {
	const query = useQuery(["key-shout", id], () => fetchKeyShout(id), {
		select: adaptKeyShout,
		enabled: !!id
	});

	return query;
};

export default useKeyShout;
